import classNames from 'classnames';
import { BaseCardProps } from '~/components/Card';
import { DefaultFace } from '~/components/Icon/DefaultFace';
import { Logo } from '~/components/Icon/Logo';
import { NftCard } from '~/components/Nft/Card';
import './PlaceholderCard.scss';

export type PlaceholderCardProps = Omit<BaseCardProps, 'color'> & {
  type: 'logo' | 'face';
  color?: 'black' | 'white';
};

export const iconByType = {
  logo: Logo,
  face: DefaultFace,
};

export const PlaceholderCard = ({
  className,
  type,
  color,
  shadow = false,
  ...props
}: PlaceholderCardProps) => {
  const PlaceholderIcon = iconByType[type];
  return (
    <NftCard
      className={classNames(
        'placeholder-card',
        {
          [`placeholder-card-type-${type}`]: type,
        },
        className
      )}
      shadow={shadow}
      {...props}>
      {PlaceholderIcon && <PlaceholderIcon className="placeholder-card-image" color={color} />}
    </NftCard>
  );
};
